import { axiosGetMultiParams, axiosGetAuthorize, axiosPostAuthorize, axiosGetFileAuthorizeblob, axiosPostFileAuthorizeblob } from '../AxiosRequests';
import {
    ApproveRenewMembershipRequest, AddEditMembershipApprovalDate, AddMembershipPaymentData, AddEditTask, RejectApplicationForMember, AddEditMembershipTaskAndSendForApproval,
    AddEditMembershipTaskAndSendPaymentLink, GetAllBillingCategories, GetAllCorporateProspectSource, GetAllDropdownsForMembershipTaskList, GetAllMembershipRevenue, GetAllMembershipTypes,
    GetAllPriceTables, GetAllSources, GetAllTasksList, GetAllTransactionaTypes, GetCalculatedFinalPrice, GetExistingDiscountTableByTaskId, GetPriceTabelByCorporateMemberId, GetTaskByCompanyId,
    SendInvoiceEmailToCorporateMember, SendQuotationEmailToCorporateMember, SendEscalateMailToMember, DeleteTaskListDetailsByTaskId, GetContactInformationDetailById, SendClarificationMailToMember,
    GetAllDetailsForGeneratePDF, GetPastDetailsPDF, GetCommitteeApprovalHistoryLogsById, SendEmailForMembershipAndManagmentCommitteeApproval, UpdateCommitteeAdditionalInformation, AddEditReinstatementPaymentDataAndSendPaymentLink, GetAllBODAndTopMangementByTaskId, GetAllCorporateMemberProjectsByTaskId, GetAllRepresentativesByTaskId, GetMembershipAndManagmentCommitteeAdministrators,
    SaveWelcomeLetterDetail
    , AddEditMembershipTask, GenerateMembershipPaymentInvoiceAndSendPaymentLink, DeleteMembershipTaskList, ResendEmailForMembershipAndManagmentCommitteeApproval
} from '../ApiEndPoints'

export default class MembershipTaskListServices {

    async getAllTaskList(request) {
        return axiosPostAuthorize(GetAllTasksList, request)
    }

    async getTaskByCompanyId(request) {
        return axiosGetAuthorize(GetTaskByCompanyId, request)
    }
    async addEditMembershipTaskAndSendForApproval(request) {
        return axiosPostAuthorize(AddEditMembershipTaskAndSendForApproval, request)
    }
    async getAllSources() {
        return axiosGetAuthorize(GetAllSources);
    }

    async getAllMembershipTypes() {
        return axiosGetAuthorize(GetAllMembershipTypes);
    }

    async getAllTransactionaTypes() {
        return axiosGetAuthorize(GetAllTransactionaTypes);
    }

    async getAllBillingCategories() {
        return axiosGetAuthorize(GetAllBillingCategories);
    }

    async getAllMembershipRevenue() {
        return axiosGetAuthorize(GetAllMembershipRevenue);
    }
    async getPriceTabelForTaskListProcess(request) {
        return axiosPostAuthorize(GetAllPriceTables, request)
    }
    async getSourceLists() {
        return axiosGetAuthorize(GetAllCorporateProspectSource);
    }
    async getAllDropdownsForTaskList() {
        return axiosGetAuthorize(GetAllDropdownsForMembershipTaskList);
    }
    async getPriceTabelByCorporateMemberId(request) {
        return axiosGetAuthorize(GetPriceTabelByCorporateMemberId, request)
    }
    async getCalculatedFinalPrice(request) {
        return axiosPostAuthorize(GetCalculatedFinalPrice, request)
    }
    async addEditMembershipTaskAndSendPaymentLink(request) {
        return axiosPostAuthorize(AddEditMembershipTaskAndSendPaymentLink, request)
    }
    async addEditReinstatementPaymentDataAndSendPaymentLink(request) {
        return axiosPostAuthorize(AddEditReinstatementPaymentDataAndSendPaymentLink, request)
    }
    async getExistingDiscountTableByTaskId(request) {
        return axiosGetAuthorize(GetExistingDiscountTableByTaskId, request)
    }
    async sendInvoiceEmailToCorporateMember(request) {
        return axiosPostAuthorize(SendInvoiceEmailToCorporateMember, request);
    }
    async sendQuotationEmailToCorporateMember(request) {
        return axiosPostAuthorize(SendQuotationEmailToCorporateMember, request);
    }
    async sendEscalateMailToMember(request) {
        return axiosPostAuthorize(SendEscalateMailToMember, request);
    }
    async deleteTaskListDetailsByTaskId(request) {
        return axiosGetAuthorize(DeleteTaskListDetailsByTaskId, request);
    }
    async rejectApplicationForMember(request) {
        return axiosPostAuthorize(RejectApplicationForMember, request);
    }
    async saveClarificationDetails(request) {
        return axiosPostAuthorize(SendClarificationMailToMember, request);
    }
    async saveWelcomeLetterDetail(request) {
        return axiosPostAuthorize(SaveWelcomeLetterDetail, request);
    }
    async approveRenewMembershipRequest(request) {
        return axiosPostAuthorize(ApproveRenewMembershipRequest, request)
    }
    async addMembershipPaymentData(request) {
        return axiosPostAuthorize(AddMembershipPaymentData, request);
    }
    async getAllDetailsForGeneratePDF(request) {
        return axiosGetFileAuthorizeblob(GetAllDetailsForGeneratePDF, request);
    }
    async GetPastDetailsPDF(request) {
        return axiosGetFileAuthorizeblob(GetPastDetailsPDF, request);
    }
    async getAllBODAndTopMangementByTaskId(request) {
        return axiosGetAuthorize(GetAllBODAndTopMangementByTaskId, request)
    }
    async getAllCorporateMemberProjectsByTaskId(request) {
        return axiosGetAuthorize(GetAllCorporateMemberProjectsByTaskId, request)
    }
    async getAllRepresentativesByTaskId(request) {
        return axiosGetAuthorize(GetAllRepresentativesByTaskId, request)
    }

    async GetCommitteeApprovalHistoryLogsById(request) {
        return axiosGetAuthorize(GetCommitteeApprovalHistoryLogsById, request)
    }
    async SendEmailForMembershipAndManagmentCommitteeApproval(request) {
        return axiosPostAuthorize(SendEmailForMembershipAndManagmentCommitteeApproval, request)
    }
    async ResendEmailForMembershipAndManagmentCommitteeApproval(request) {
        return axiosPostAuthorize(ResendEmailForMembershipAndManagmentCommitteeApproval, request)
    }
    async AddEditMembershipTask(request) {
        return axiosPostAuthorize(AddEditMembershipTask, request)
    }
    async GenerateMembershipPaymentInvoiceAndSendPaymentLink(request) {
        return axiosPostAuthorize(GenerateMembershipPaymentInvoiceAndSendPaymentLink, request)
    }
    async UpdateCommitteeAdditionalInformation(request) {
        return axiosPostAuthorize(UpdateCommitteeAdditionalInformation, request)
    }

    async deleteMembershipTaskList(request) {
        return axiosPostAuthorize(DeleteMembershipTaskList, request)
    }

}
